/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "theme-ui"

export default ({ children }) => (
    <h2 sx={{ 
      fontSize: [5],
      fontWeight: "bold", 
      fontFamily: "heading", 
      lineHeight: .9, 
    }}>
      {children}
    </h2>
)

